import * as moment from 'moment-timezone';

const tzGuess = moment.tz.guess();
export const mtz = (dateStr?:string | Date) => moment.tz(dateStr, tzGuess);